module.exports = __webpack_public_path__ + "img/Screenshot_2021-05-28 Parti Yorkies of the Grove(2).e565b3a8.png";